/**
 * @description header2 button menu
 * @author wangfupeng
 */

import HeaderButtonMenuBase from './HeaderButtonMenuBase'

class Header2ButtonMenu extends HeaderButtonMenuBase {
  title = 'H2'

  type = 'header2'
}

export default Header2ButtonMenu
